module.exports = __webpack_public_path__ + "static/media/xlsx.e4531bb0.png";